import { mediaGQLFields } from '@tribeplatform/gql-client';
const BASIC_BADGE_FIELDS = {};
const ALL_BADGE_FIELDS = {
    image: 'all',
};
const DEFAULT_BADGE_FIELDS = {
    image: 'all',
};
const BASIC_MEMBER_BADGE_FIELDS = {};
const ALL_MEMBER_BADGE_FIELDS = {
    badge: 'all',
};
const DEFAULT_MEMBER_BADGE_FIELDS = {
    badge: 'default',
};
export function badgeGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_BADGE_FIELDS;
    if (fields === 'all')
        fields = ALL_BADGE_FIELDS;
    if (fields === 'default')
        fields = DEFAULT_BADGE_FIELDS;
    return `
    active
    backgroundColor
    daysUntilExpired
    id
    imageId
    longDescription
    name
    shortDescription
    textColor
    text
    type
    settings {
      key
      value
    }
    ${fields.image
        ? `
        image {
          ${mediaGQLFields(fields.image)}
        }
    `
        : ''}    
  `;
}
export function memberBadgeGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_MEMBER_BADGE_FIELDS;
    if (fields === 'all')
        fields = ALL_MEMBER_BADGE_FIELDS;
    if (fields === 'default')
        fields = DEFAULT_MEMBER_BADGE_FIELDS;
    return `
    backgroundColor
    badgeId
    imageId
    longDescription
    text
    shortDescription
    textColor
    type
    ${fields.badge
        ? `
    badge {
      ${badgeGQLFields(fields.badge)}
    }
    `
        : ''}
  `;
}
